module.exports = __webpack_public_path__ + "img/rw-code-summit.19781b36.png";